import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Redux 

import { setHackerData, setSecurityData } from '../../../../redux/features/hacker/data/hackerData';

// Routes 

import { getSecurityData } from '../../../../routes/hacker/users';

// Components 

import Box from '@mui/material/Box';
import Table from './table/Table';
import DataBox from '../../../general/data/DataBox';
import DataRow from '../../../general/data/DataRow';

// Icons 

import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';

import ApartmentIcon from '@mui/icons-material/Apartment';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

const Security: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 

    const securityData = useAppSelector(state => state.hackerData.securityData);
    const colors = useAppSelector(state => state.theme.colors);  

    // -- 

    const handleData = async () => { 

      const res = await getSecurityData() as any;  

      if (res.data.status === 200) { 

        dispatch(setSecurityData(res.data.data)); 

      }; 

    }; 

    // -- 

    useEffect(() => { 

      if (!securityData) { 

        handleData();

      };

    },[securityData]);

    // -- 

    return (

      <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', 
          width: '100%',
          height: '100%', 
          overflow: 'scroll',
          overflowX: 'hidden', 
          scrollbarWidth: 'none',
          paddingTop: 2, 
          paddingBottom: 3, 
          backgroundColor: colors?.interface 
      }}>

        {/* <Table /> */}

        <DataBox title='Clinics (Groups)'>

            <DataRow  icon={<ToggleOnIcon sx={{ color: 'rgb(56, 194, 56)' }} />} title={'Active'} data={securityData?.groups?.active} />

            <DataRow  icon={<ApartmentIcon sx={{ color: colors?.main }} />} title={'Total'} data={securityData?.groups?.total} />

        </DataBox>  

        <DataBox title='Doctor Accounts'>

          <DataRow  icon={<PersonIcon sx={{ color: 'green' }} />} title={'Active'} data={securityData?.doctorAccounts?.active} />

          <DataRow  icon={<PersonSearchIcon sx={{ color: 'orange' }} />} title={'Pending'} data={securityData?.doctorAccounts?.pending} />

          <DataRow  icon={<PersonOffIcon sx={{ color: 'red' }} />} title={'Deleted'} data={securityData?.doctorAccounts?.deleted} />

        </DataBox> 

        <DataBox title='Registration'>

          <DataRow  icon={<TodayIcon sx={{ color: colors?.main }} />} title={'Last Day'} data={securityData?.registration?.lastDay} />

          <DataRow  icon={<CalendarMonthIcon sx={{ color: 'blue' }} />} title={'Last Month'} data={securityData?.registration?.lastMonth} />

          <DataRow  icon={<EventNoteIcon sx={{ color: 'darkblue' }} />} title={'Total'} data={securityData?.registration?.total} />

        </DataBox> 

        <DataBox title='Login Attempts' description='(Total / Success rate (%))'>

          <DataRow  icon={<QueryBuilderIcon sx={{ color: 'rgb(68, 199, 42)' }} />} title={'Last Hour'} data={securityData?.loginAttempts?.lastHour} />

          <DataRow  icon={<TodayIcon sx={{ color: 'rgb(58, 189, 32)' }} />} title={'Last Day'} data={securityData?.loginAttempts?.lastDay} />

          <DataRow  icon={<CalendarMonthIcon sx={{ color: 'rgb(37, 146, 21)' }} />} title={'Last Month'} data={securityData?.loginAttempts?.lastMonth} />

          <DataRow  icon={<EventNoteIcon sx={{ color: 'rgb(32, 119, 16)' }} />} title={'Total'} data={securityData?.loginAttempts?.total} />

        </DataBox> 

        <DataBox title='Consultation Notes'>

          <DataRow  icon={<QueryBuilderIcon sx={{ color: 'rgb(199, 118, 42)' }} />} title={'Last Hour'} data={securityData?.notes?.lastHour} />

          <DataRow  icon={<TodayIcon sx={{ color: 'rgb(172, 101, 34)' }} />} title={'Last Day'} data={securityData?.notes?.lastDay} />

          <DataRow  icon={<CalendarMonthIcon sx={{ color: 'rgb(146, 86, 29)' }} />} title={'Last Month'} data={securityData?.notes?.lastMonth} />

          <DataRow  icon={<EventNoteIcon sx={{ color: 'rgb(99, 58, 21)' }} />} title={'Total'} data={securityData?.notes?.total} />

        </DataBox> 



      </Box>

  );

};

export default Security;